import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from 'src/app/services/app-state.service';

@Component({
  selector: 'app-accept-contract',
  templateUrl: './accept-contract.component.html',
  styleUrls: ['./accept-contract.component.scss']
})
export class AcceptContractComponent implements OnInit {

  constructor(private appState: AppStateService, private router: Router) { }

  ngOnInit() {
  }

  next() {
    this.appState.setLoading(true).then(() => {
      setTimeout(() => {
        this.router.navigate(['send-charges']);
        this.appState.setLoading(false);
      }, 3000);
    });
  }

}
